<div class="col-md-12 mb-30" *ngIf="Selected_DeviceBehfaFilterGroup_Record_Switcher=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">لیست گروه های فیلتر</h5>
     <br/>
     <br/>

     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">عنوان</label>
        <input [(ngModel)]="Filter_Title" (keyup)="Change_Filter()" name="Filter_Title" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>

    </div>

     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="Set_Form_DeviceBehfaFilterGroup_View_Add()"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus"></i> فرم ثبت اطلاعات جدید</button>
        <button *ngIf="!Procssing" type="button" (click)="ReadData_DeviceBehfaFilterGroup()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

     <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>عنوان</th>
              <th>ثبت کننده</th>
              <th>تاریخ</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfaFilterGroup
            |filter:Filter_Title:'title'
            | paginate
                    : {
                        id: 'DataList_DeviceBehfaFilterGroup',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceBehfaFilterGroup
                          |filter:Filter_Title:'title'
                        ).length
                      }
            ">
             <td>{{DataList_DeviceBehfaFilterGroup.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.username}}</td>
              <td>{{item.persianDate}}</td>
              <td>
                <div class="btn-group  " DeviceBehfaFilterGroup="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" DeviceBehfaFilterGroup="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" class="dropdown-item" (click)="DeleteModal(templateDelete,item)" ><i class="fa  fa-remove"></i>حذف</a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Form_DeviceBehfaFilterGroup_View(item,'Form')" ><i class="fa  fa-edit"></i>ویرایش</a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Form_DeviceBehfaFilterGroup_View(item,'Device')" ><i class="fa fa-building"></i>تجهیز</a>
                      </div>
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>

    </div>

    <pagination-controls id="DataList_DeviceBehfaFilterGroup" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>

  </div>
</div>

<div  class="col-md-12 mb-30" *ngIf="Selected_DeviceBehfaFilterGroup_Record_Switcher=='Form'">
  <app-DeviceBehfaFilterGroupForm [inner_DeviceBehfaFilterGroup]="Selected_DeviceBehfaFilterGroup_Record"
  (outter_DeviceBehfaFilterGroup)="Set_List_DeviceBehfaFilterGroup_View($event)">
  </app-DeviceBehfaFilterGroupForm>
</div>

<div  class="col-md-12 mb-30" *ngIf="Selected_DeviceBehfaFilterGroup_Record_Switcher=='Device'">
  <app-DeviceBehfaFilterGroupDetail [inner_DeviceBehfaFilterGroup]="Selected_DeviceBehfaFilterGroup_Record"
  (outter_DeviceBehfaFilterGroup)="Set_List_DeviceBehfaFilterGroup_View($event)">
  </app-DeviceBehfaFilterGroupDetail>
</div>


<ng-template #templateDelete>
  <div class="modal-header">
    <h4 class="modal-title pull-left">تایید حذف اطلاعات گروه
      '{{DeviceBehfaFilterGroup_Record_Delete.title}}' </h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">

    <button  type="button" class="btn btn-warning"
      (click)="Delete()"> حذف اطلاعات <i class="fa fa-remove"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>
